import type { DeliveryStop, TripRecord } from '@/features/delman/storage/tripStorage'

/** Mock: toko scan QR ~12 detik setelah QR ditampilkan. */
const MOCK_SCAN_DELAY_MS = 12_000
/** Mock: toko selesai terima ~20 detik setelah draft. */
const MOCK_COMPLETE_AFTER_DRAFT_MS = 20_000

export type StoreScannedEvent = {
  deliveryId: string
  storeName: string
}

export type StoreCompletedEvent = {
  deliveryId: string
  storeName: string
}

export type ReceivingPollResult = {
  trip: TripRecord
  newlyScanned: StoreScannedEvent[]
  newlyCompleted: StoreCompletedEvent[]
}

function completeStop(stop: DeliveryStop): DeliveryStop {
  return {
    ...stop,
    status: 'receiving_completed',
    receivingStatus: 'completed',
    lines: stop.lines.map((line) => ({
      ...line,
      qtyReceived: line.qtyShipped,
    })),
  }
}

export function applyMockReceivingPoll(trip: TripRecord): ReceivingPollResult {
  const now = Date.now()
  const newlyScanned: StoreScannedEvent[] = []
  const newlyCompleted: StoreCompletedEvent[] = []

  const stops = trip.stops.map((stop) => {
    if (
      stop.receivingStatus === 'draft' &&
      stop.receivingDraftAt &&
      now - new Date(stop.receivingDraftAt).getTime() >= MOCK_COMPLETE_AFTER_DRAFT_MS
    ) {
      newlyCompleted.push({ deliveryId: stop.id, storeName: stop.storeName })
      return completeStop(stop)
    }

    if (stop.status !== 'qr_shown' || stop.receivingStatus !== 'none' || !stop.qrShownAt) {
      return stop
    }
    if (now - new Date(stop.qrShownAt).getTime() < MOCK_SCAN_DELAY_MS) {
      return stop
    }

    newlyScanned.push({ deliveryId: stop.id, storeName: stop.storeName })
    return {
      ...stop,
      receivingStatus: 'draft' as const,
      status: 'receiving_draft' as const,
      receivingDraftAt: new Date().toISOString(),
    }
  })

  const changed = newlyScanned.length > 0 || newlyCompleted.length > 0
  return {
    trip: changed ? { ...trip, stops } : trip,
    newlyScanned,
    newlyCompleted,
  }
}

export function tripNeedsReceivingPoll(trip: TripRecord): boolean {
  return trip.stops.some(
    (s) =>
      (s.status === 'qr_shown' && s.receivingStatus === 'none') || s.receivingStatus === 'draft',
  )
}

/** @deprecated Gunakan tripNeedsReceivingPoll */
export function tripHasAwaitingStoreScan(trip: TripRecord): boolean {
  return tripNeedsReceivingPoll(trip)
}
